// Mobilní panel hledání (mobileSearch.js).
export default {
  back: 'Zpět',
  clear: 'Smazat dotaz',
  popular: 'Nejhledanější',
  cats: 'Nejčastější kategorie',
  cta: 'Zobrazit všechny výsledky',
};
